//#region ../src/ar/depth-grid-lookup.ts
/** A node's depth if finite and positive, else `null` (a grid hole). */
function validDepth(points, index) {
	const p = points[index];
	if (!p) return null;
	const d = p.depthM;
	return Number.isFinite(d) && d > 0 ? d : null;
}
/**
* Build a bilinear lookup over a depth-sampler grid.
*
* @param points - the grid `DepthPoint`s (row-major, `row·g + col`).
* @param gridSize - points-per-side; inferred as `round(√points.length)` when
*   omitted (the sampler always emits a full `g²` grid).
*/
function createDepthGridLookup(points, gridSize) {
	const g = gridSize ?? Math.round(Math.sqrt(points.length));
	if (g < 2 || points.length < g * g) return { depthAt() {
		for (let i = 0; i < points.length; i++) {
			const d = validDepth(points, i);
			if (d !== null) return d;
		}
		return null;
	} };
	return { depthAt(screenX, screenY) {
		const gx = screenX * (g + 1) - 1;
		const gy = screenY * (g + 1) - 1;
		if (gx < 0 || gx > g - 1 || gy < 0 || gy > g - 1) return null;
		const col0 = Math.min(Math.floor(gx), g - 2);
		const row0 = Math.min(Math.floor(gy), g - 2);
		const fx = gx - col0;
		const fy = gy - row0;
		const d00 = validDepth(points, row0 * g + col0);
		const d10 = validDepth(points, row0 * g + col0 + 1);
		const d01 = validDepth(points, (row0 + 1) * g + col0);
		const d11 = validDepth(points, (row0 + 1) * g + col0 + 1);
		if (d00 === null || d10 === null || d01 === null || d11 === null) return null;
		const top = d00 + (d10 - d00) * fx;
		return top + (d01 + (d11 - d01) * fx - top) * fy;
	} };
}
//#endregion
export { createDepthGridLookup };
